import { render } from "./BaseVioletButton.vue?vue&type=template&id=7255842a"
import script from "./BaseVioletButton.vue?vue&type=script&lang=js"
export * from "./BaseVioletButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__